<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="450"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="form-head">
            Producto a medida
        </div>

        <div class="pl-3 pt-3 pr-3">
            <v-card class="card-form">
                <v-card-text class="pt-1 pb-1 pr-1 pl-1">
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    ref="name"
                                    v-model="form.name"
                                    outlined
                                    label="Producto"
                                    hide-details
                                    dense                                    
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-textarea
                                    v-model="form.description"
                                    outlined
                                    label="Detalles"
                                    hide-details
                                    rows="6"
                                >
                                </v-textarea>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field
                                    v-model="form.quantity"
                                    outlined
                                    label="Cantidad"
                                    hide-details
                                    type="number"
                                    dense
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field
                                    v-model="form.price"
                                    outlined
                                    label="Precio Und."
                                    hide-details
                                    type="number"
                                    dense
                                    prefix="S/"
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <!--
                        <v-row>
                            <v-col cols="3">
                                <v-btn-toggle
                                    v-model="form.discount_type"
                                    mandatory
                                    dense
                                    color="green darken-3">
                                    <v-btn value="Monto" class="btn-show-mode">
                                        S/ 
                                    </v-btn>
                                    <v-btn value="Porcentaje" class="btn-show-mode">
                                        %
                                    </v-btn>
                                </v-btn-toggle>
                            </v-col>
                            <v-col cols="9">
                                <v-text-field :label="`${form.discount_type} a descontar`"
                                    outlined
                                    dense
                                    v-model="form.discount_amount">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        -->
                    </v-container>
                </v-card-text>
            </v-card>
        </div>

        <div class="mt-3 pl-3 pt-3 pr-3">
            <template>
                <v-row>
                    <v-col cols="6">
                        <v-btn class="mr-5" 
                            block
                            color="error" 
                            outlined 
                            @click="handleCancel()" :elevation="10"
                            height="40">
                            Cancelar
                        </v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-btn color="primary"
                            block
                            raised 
                            @click="handleAddCustomProduct()" :elevation="10"
                            height="40">
                            Guardar
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
        </div>
    </v-navigation-drawer>
</template>

<script>
import {mapActions, mapMutations} from 'vuex';

export default {
    name: 'CustomProduct',
    data () {
        return {
            drawer: false,
            form: {
                name: null,
                description: null,
                quantity: null,
                price: null,
                discount_type: null,
                discount_amount: null
            }
        }
    },
    methods: {
        ...mapMutations('sales', [
            'setProduct',            
        ]),
        ...mapActions('sales', [
            'selectProduct'
        ]),
        show () {
            this.clearForm();
            this.drawer = !this.drawer;
        },
        clearForm () {
            this.form.name = null;
            this.form.description = null;
            this.form.quantity = null;
            this.form.price = null
        },
        closeForm () {
            this.drawer = false;
        },
        handleCancel () {
            this.closeForm();
        },
        handleAddCustomProduct () {
            let validate = this.validateData();
            if(validate.error) {
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'RESULTADO DE INGRESO DE PEDIDO',
                    text: validate.message
                })
            } else {
                let customProduct = this.settingProduct(this.form);
                this.setProduct(customProduct);
                this.selectProduct();
                this.closeForm();
            }            
        },
        settingProduct (item) {
            let today = new Date();

            let price = parseFloat(item.quantity) * parseFloat(item.price);
            let customProduc = {
                id: today.getTime(),
                name: item.name.toUpperCase(),
                description: item.description.toUpperCase(),
                unit_price: parseFloat(item.price),
                wholesale_price: parseFloat(item.price),
                preferential_price: parseFloat(item.price),
                base_price: parseFloat(item.price),
                price: parseFloat(price),
                discount_type: null,
                discount_amount: 0,
                discount_value: 0,
                quantity: parseFloat(item.quantity),
                has_return: false,
                type_product: 'custom'
            }

            return customProduc;
        },
        validateData(){
            let error = false
            let message = ""
            if (this.form.name == null) {
                error = true
                message = "Debe ingresar el nombre del producto."
            }
            else if (this.form.description == null) {
                error = true
                message = "Debe ingresar el detalle del producto."
            }
            else if (this.form.quantity == null) {
                error = true
                message = "Debe ingresar una cantidad."
            }
            else if (this.form.price == null) {
                error = true
                message = "Debe ingresar el precio."
            }

            return {
                error,
                message
            }
        },
    }
}
</script>

<style scoped>
.card-form{
    height: 75vh;
}

.btn-show-mode{
    min-width: 50px !important;
}
</style>